import { Component, inject, OnInit, Optional, ViewChild } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { BehaviorSubject, firstValueFrom, Subject, Subscription } from 'rxjs';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { CustomTableSelectComponent } from 'src/app/components/custom-table-select/custom-table-select.component';
import { MaintenanceOrderEnums } from 'src/app/enum/maintenance-order-enum';
import { ActionColor, CheckBoxAction, TableAction } from 'src/app/interfaces/custom-table/custom-table-action.interface';
import { MaintenanceOrderSuppliesModel } from 'src/app/models/maintenance/maintenance-order-supplies.model';
import { MaintenanceOrderModel } from 'src/app/models/maintenance/maintenance-order.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { MaintenanceOrderSuppliesTableModel } from 'src/app/models/tables/maintenance/maintenance-order-supplies-table.model';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { MaintenanceOrderSuppliesService } from 'src/app/services/maintenance/maintenance-order-supplies.service';
import { MaintenanceRoutineSupplyService } from 'src/app/services/maintenance/maintenance-routine-supply.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-maintenance-order-supplies',
  templateUrl: './maintenance-order-supplies.component.html',
  styleUrls: ['./maintenance-order-supplies.component.scss'],
  standalone: false
})
export class MaintenanceOrderSuppliesComponent implements OnInit {
  public config = inject(DynamicDialogConfig);
  private readonly confirmDialogService = inject(ConfirmDialogService);
  private readonly maintenanceOrderSuppliesService = inject(MaintenanceOrderSuppliesService);
  private readonly maintenanceRoutineSupplyService = inject(MaintenanceRoutineSupplyService);
  private readonly toastHandlerService = inject(ToastHandlerService);
  @Optional() private ref = inject(DynamicDialogRef);

  @ViewChild('articleSelection') articleSelectionModalComponent?: CustomModalComponent | null = null;


  ascendant: boolean = true;
  ascendantArticle: boolean = true;
  columnSortArticle: string | null = null;
  componentTableSelection = CustomTableSelectComponent;
  dataArticle: PagedResponseModel<any> = new PagedResponseModel<any>();
  checkboxActions: CheckBoxAction[] = [
    {
      label: 'Eliminar',
      icon: 'pi pi-trash',
      color: ActionColor.DANGER,
      action: 'bulk-delete'
    },
  ];
  clearSelectionTrigger: number = 0;
  columnSort: string | null = null;
  columns: ColumnResponseModel[] = [];
  data: PagedResponseModel<any> = new PagedResponseModel<any>();
  disabledActions: boolean = false;
  filtersArticle: ColumnResponseModel[] = [];
  haveArticleHomologous: boolean = false;
  headerArticle: ColumnResponseModel[] = [];
  inputsForArticlesSelection$ = new BehaviorSubject<any>({
    headers: [],
    data: [],
    showCheckbox: false,
    showRecover: true,
    isMultipleSelect: false,
    filters: [],
  });

  limitArticle: number = 10;
  isFormView: boolean = false;
  limit: number = 10;
  maintenanceOrderModel: MaintenanceOrderModel = new MaintenanceOrderModel();
  maintenanceOrderSuppliesModel: MaintenanceOrderSuppliesModel = new MaintenanceOrderSuppliesModel();
  output$: Subject<any> = new Subject<any>();
  page: number = 1;
  pageArticle: number = 1;
  permissionUpdatable: boolean = false;
  subscription: Subscription;
  tableActions: TableAction[] = [];

  constructor() { }

  async ngOnInit() {
    const input$ = this.config.data?.inputs$;
    if (!input$) {
      console.error('inputs$ no está definido en config.data');
      return;
    }
    this.subscription = input$?.subscribe((inputs: any) => {
      this.maintenanceOrderModel = inputs.maintenanceOrderModel;
      this.permissionUpdatable = inputs.permissionUpdatable;
    });

    this.subscription = this.output$.subscribe(({ type, payload }) => {
      switch (type) {
        case 'onPageChange':
          this.onPageChangeArticle(payload);
          break;
        case 'onFilterChange':
          this.onFilterChange(payload);
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });

    if (this.maintenanceOrderModel.maintenanceOrderStateId == MaintenanceOrderEnums.abierta) {
      this.tableActions = this.getDefaultActions();
      this.disabledActions = true;
    }

    await Promise.all([
      this.getColumns(),
      this.getAllMaintenanceOrderSuppliesWithPagination()
    ])
  }

  async addSupplies() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('error', `El usuario no tiene permisos para agregar insumos de la orden de mtto.
            Comuníquese con el administrador del sistema.`);
      return;
    }

    if (!this.maintenanceOrderModel.maintenancePlan) {
      this.toastHandlerService.showToast('error', `La orden de mtto no tiene un plan de mtto.`);
      return;
    }

    try {
      await firstValueFrom(this.maintenanceOrderSuppliesService.createSuppliesByMaintenancePlan(this.maintenanceOrderModel.maintenanceOrderId, this.maintenanceOrderModel.articleId, this.maintenanceOrderModel.maintenancePlan));
      await this.getAllMaintenanceOrderSuppliesWithPagination();
      this.toastHandlerService.showToast('success', 'Los insumos fueron agregados exitosamente.');
    } catch (error) {
      console.error('Error al agregar los insumos.', error);
    }
  }

  async deleteMaintenanceOrderSupply(selectedIds: number[]) {
    if (selectedIds.length === 0) return;

    const confirmation = await this.confirmDialogService.confirm('¿Realmente desea eliminar el insumo de la orden de mantenimiento?')
    if (confirmation) {
      try {
        await firstValueFrom(this.maintenanceOrderSuppliesService.deleteSomeSupplies(selectedIds));
        this.toastHandlerService.showToast('success', 'El insumo fue eliminado exitosamente.', 'Atención');
      } catch (error) {
        console.error('Error al eliminar el insumo de la orden de mantenimiento .', error);
      }
    };
  }

  async getAllSupplies() {
    try {
      this.dataArticle = await firstValueFrom(this.maintenanceRoutineSupplyService.getAllSupplies(this.pageArticle, this.limitArticle, this.columnSortArticle, this.ascendantArticle, this.filtersArticle));
      this.updateInputs();
    } catch (error) {
      console.error('Error al obtener la lista de los artículos', error);
    }
  }

  getDefaultActions(): TableAction[] {
    return [
      {
        label: 'Editar',
        icon: 'pi pi-pencil',
        action: 'edit'
      }
    ];
  }

  async getColumns() {
    try {
      this.columns = await firstValueFrom(this.maintenanceOrderSuppliesService.getColumnsForTable());
    } catch (error) {
      console.error('Error al buscar las columnas para la consulta.', error);
    }
  }

  async getColumnsArticle() {
    try {
      this.headerArticle = await firstValueFrom(this.maintenanceRoutineSupplyService.getColumnsForArticlesAsync());
    } catch (error) {
      console.error('Error al buscar las columnas para la selección de artículos.', error);
    }
  }

  async getAllMaintenanceOrderSuppliesWithPagination() {
    try {
      this.data = await firstValueFrom(this.maintenanceOrderSuppliesService.getAllMaintenanceOrderSuppliesWithPagination(this.maintenanceOrderModel.maintenanceOrderId,
        this.page, this.limit, this.columnSort, this.ascendant));
      this.haveArticleHomologous = this.data.items.filter(x => x.swHomologous == "SI").length > 0;
    } catch (error) {
      console.error('Error al obtener la lista de los insumos.', error);
    }
  }

  getFormView(event: boolean) {
    this.isFormView = event;
  }

  async handleSelectedItem(selectedItem: any) {
    const articleId = parseInt(selectedItem[0]?.id);
    this.maintenanceOrderSuppliesModel = await firstValueFrom(this.maintenanceOrderSuppliesService.getMaintenanceOrderSuppliesByKeysAsync(this.maintenanceOrderModel.maintenanceOrderId, articleId));
    this.getFormView(true);
  }

  async newSupplies() {
    this.filtersArticle = [];
    await Promise.all([
      this.getColumnsArticle(),
      this.getAllSupplies()]
    );
    this.updateInputs();
    this.articleSelectionModalComponent && this.articleSelectionModalComponent.show();
  }

  async onAction(event: { action: string, item?: MaintenanceOrderSuppliesTableModel, selectedItems?: number[] }) {
    if (event.action === 'edit') {
      const response = await firstValueFrom(this.maintenanceOrderSuppliesService.getMaintenanceOrderSuppliesById(event.item!.id));
      if (response) {
        this.maintenanceOrderSuppliesModel = response;
      }
      this.getFormView(true);
    }

    if (event.action === 'bulk-delete' && event.selectedItems) {
      await this.deleteMaintenanceOrderSupply(event.selectedItems);
      this.getAllMaintenanceOrderSuppliesWithPagination();
      this.clearSelectionTrigger++;
      this.maintenanceOrderSuppliesModel = new MaintenanceOrderSuppliesModel();
      this.getFormView(false);
    }
  }

  async onPageChange(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.page = event.page;
    this.limit = event.pageSize;
    this.columnSort = event.sortField || null;
    this.ascendant = event.sortOrder === 1;
    this.getAllMaintenanceOrderSuppliesWithPagination();
  }

  async onPageChangeArticle(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.pageArticle = event.page;
    this.limitArticle = event.pageSize;
    this.columnSortArticle = event.sortField || null;
    this.ascendantArticle = event.sortOrder === 1;
    this.getAllSupplies();
  }

  async onFilterChange(event: { filters: any }) {
    const filters = event.filters
      .map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index)
      .map((item: any) => item.value);
    this.filtersArticle = this.removeDuplicates(filters);
    this.filtersArticle.forEach((filter: any) => this.processFilter(filter));
    this.updateInputs();
  }

  processFilter(filter: any): void {
    const { propertyName, valueFilter, valueAlterFilter } = filter;
    if (valueFilter === null || valueFilter === undefined || valueFilter === '' || valueFilter === 0) {
      this.filtersArticle = this.filtersArticle.filter(f => f.propertyName !== propertyName);
    } else {
      const existingFilter = this.filtersArticle.find(f => f.propertyName === propertyName);
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }

  removeDuplicates(filters: any[]): any[] {
    return filters.filter((value, index, self) =>
      index === self.findIndex((t: any) => t.propertyName === value.propertyName)
    );
  }

  updateInputs() {
    this.inputsForArticlesSelection$.next({
      headers: this.headerArticle,
      data: this.dataArticle,
      showCheckbox: true,
      showRecover: true,
      isMultipleSelect: false,
      filters: this.filtersArticle,
    });
  }


}
